export const errorInvoicesLoaiThongBao = [
  { key: "type1", value: "1", label: "Thông báo hủy/giải trình của NNT" },
  {
    key: "type2",
    value: "2",
    label: "Thông báo hủy/giải trình của NNT theo thông báo của CQT",
  },
];

export const MODE = {
  EDIT: "EDIT",
  VIEW: "VIEW",
};

export const errorInvoicesLoaiHoaDon = [
  { key: "TT78", value: "1", label: "Thông tư 78" },
  { key: "TT32", value: "2", label: "Thông tư 32" },
  { key: "ND51", value: "3", label: "Nghị định 51" },
  { key: "HD_Giay", value: "4", label: "Hóa đơn giấy" },
];

export const KyHieuMauHoaDonList = [
  { key: "VAT", value: "1", label: "1 - Hóa đơn GTGT", prefix: "T" },
  { key: "SALE", value: "2", label: "2 - Hóa đơn bán hàng", prefix: "T" },
  { key: "TICKETS", value: "5", label: "5 - Hóa đơn tem phiếu", prefix: "G" },
  { key: "WAREHOUSES", value: "6", label: "6 - Phiếu xuất kho", prefix: "N" },
];

export const invoiceTypeMode = {
  HAVE_CODE: "1",
  NONE_CODE: "0",
};

export const convertDate = (data, format = "") => {
  const type = typeof data;
  let date = null;
  if (type === "object") {
    if (format === "date") {
      let dateSet = new Date(data);
      let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
        dateSet
      );
      let mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
        dateSet
      );
      let da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
        dateSet
      );

      date = `${ye}-${mo}-${da} 00:00:00`;
    } else {
      date = Math.round(new Date(data).getTime() / 1000);
    }
  } else {
    date = data;
  }
  return date;
};

export const tableFormateDate = (data, isSecond = false) => {
  if (new Date(Number(data)).toString() !== "Invalid Date") {
    if (isSecond) {
      return Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "numeric",
      }).format(data * 1000);
    } else {
      return Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      }).format(data * 1000);
    }
  }
  return "";
};
